import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import { httpAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@api/manage';
import { initial } from 'lodash';
export default {
  name: 'IotNetworkCardModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  data: function data() {
    return {
      title: '物联网卡信息表单',
      tableName: 'site_iot_network_card',
      form_fields: ['siteId', 'cardNo', 'remark', 'keyId', 'residualFlow', 'remindTime'],
      form_fields_time: [],
      validatorRules: {
        cardNo: {
          rules: [{
            required: true,
            message: '请输入卡号!'
          }]
        },
        keyId: {
          rules: [{
            required: true,
            message: '请选择密钥!'
          }]
        }
      },
      url: {
        queryKeyName: '/site/iot/key/queryExistKey'
      },
      siteName: '',
      siteId: '',
      keyNameList: []
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    },
    currentSiteName: function currentSiteName(newVal) {
      this.siteName = newVal;
      console.log('newVal', newVal);
    }
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    moment: moment,
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.loadKeyName();
      console.log('this.model', this.model);

      if (this.model.id) {
        this.siteName = this.model.siteName;
      } else {
        this.model.siteId = this.siteId;
      }

      this.visible = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          delete formData.recordItem;
          console.log(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          console.log('222222');
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    loadKeyName: function loadKeyName() {
      var that = this;
      that.keyNameList = [];
      getAction(this.url.queryKeyName).then(function (res) {
        if (res.success) {
          that.keyNameList = res.result;
        }
      });
    }
  }
};